<template>
  <div>
    {{description}}
  </div>
</template>

<script>

import TimesheetOperationTypeEnum from "../../TimesheetOperationTypeEnum";

export default {
  name: 'TimesheetOperationTypeCellRenderer',
  data() {
    return {
      timesheetOperationType: null
    }
  },
  created() {
    this.timesheetOperationType = this.params.value.timesheetOperationType;
  },
  computed: {
    description() {
      return TimesheetOperationTypeEnum.getNameFor(this.timesheetOperationType)
    }
  }
}
</script>
